import { ICircle, IRectangle } from './math-utils';

export function testCircleRectangleCollision(circle: ICircle, rect: IRectangle): boolean {
  const rectHalfWidth = rect.width * 0.5;
  const rectHalfHeight = rect.height * 0.5;

  const cx = Math.abs(circle.x - rect.x - rectHalfWidth);
  const xDist = rectHalfWidth + circle.radius;

  if (cx > xDist) return false;

  const cy = Math.abs(circle.y - rect.y - rectHalfHeight);
  const yDist = rectHalfHeight + circle.radius;

  if (cy > yDist) return false;
  if (cx <= rectHalfWidth || cy <= rectHalfHeight) return true;

  const xCornerDist = cx - rectHalfWidth;
  const yCornerDist = cy - rectHalfHeight;
  const xCornerDistSq = xCornerDist * xCornerDist;
  const yCornerDistSq = yCornerDist * yCornerDist;
  const maxCornerDistSq = circle.radius * circle.radius;

  return xCornerDistSq + yCornerDistSq <= maxCornerDistSq;
};